import React from "react";
import { FaPhone, FaMailBulk } from 'react-icons/fa';
import Footer from '../Footer';
import './Kontakt.css';

const CONTACT_INFO = {
  phone: {
    number: "+385 1 655 1331",
    href: "tel:+38516551331"
  },
  email: {
    address: "amb.pezo@gmail.com",
    href: "mailto:amb.pezo@gmail.com"
  },
  address: {
    street: "Ulica Ede Murtića 2",
    city: "10000 Zagreb, Hrvatska"
  },
  workingHours: {
    weekdays: "Ponedjeljak - Petak: 09:00 - 20:00",
    saturday: "Subota: 09:00 - 14:00",
    sunday: "Nedjelja: Zatvoreno"
  }
};

const MAP_CONFIG = {
  src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2782.589761847371!2d15.9806470763547!3d45.77941121235201!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4765d676d3968ae5%3A0xef243e5854886b09!2sDr.%20Pezo%20-%20specijalisti%C4%8Dka%20veterinarska%20praksa%20za%20male%20%C5%BEivotinje!5e0!3m2!1sen!2shr!4v1767070809564!5m2!1sen!2shr",
  title: "Dr. Pezo Office Location",
  height: 500
};

const INFO_CARDS = [
  {
    id: 'contact',
    icon: '📞',
    title: 'Kontaktirajte nas',
    description: 'Za sve dodatne informacije i zakazivanje pregleda',
    details: [
      {
        icon: FaPhone,
        text: CONTACT_INFO.phone.number,
        href: CONTACT_INFO.phone.href,
        type: 'phone'
      },
      {
        icon: FaMailBulk,
        text: CONTACT_INFO.email.address,
        href: CONTACT_INFO.email.href,
        type: 'email'
      }
    ]
  },
  {
    id: 'hours',
    icon: '⏱️',
    title: 'Radno vrijeme',
    description: null,
    details: [
      { text: CONTACT_INFO.workingHours.weekdays },
      { text: CONTACT_INFO.workingHours.saturday },
      { text: CONTACT_INFO.workingHours.sunday }
    ]
  },
  {
    id: 'location',
    icon: '📍',
    title: 'Lokacija',
    description: null,
    details: [
      { text: CONTACT_INFO.address.street },
      { text: CONTACT_INFO.address.city }
    ]
  }
];

export default function Kontakt() {
  return (
    <>
      <main className="kontakt-container">
        <div className="map-container">
          <iframe
            title={MAP_CONFIG.title}
            src={MAP_CONFIG.src}
            width="100%"
            height={MAP_CONFIG.height}
            style={{ border: 0, borderRadius: '12px' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className="info-cards-grid">
          {INFO_CARDS.map((card) => (
            <article key={card.id} className="info-card">
              <div className="info-card-icon" aria-hidden="true">
                {card.icon}
              </div>
              <h3>{card.title}</h3>
              {card.description && <p>{card.description}</p>}
              
              {card.details.map((detail, index) => (
                <div 
                  key={index} 
                  className={`info-card-detail ${detail.type === 'phone' || detail.type === 'email' ? 'contact-detail' : ''}`}
                >
                  {detail.icon && (
                    <span className="inline-icon">
                      <detail.icon />
                    </span>
                  )}
                  {detail.href ? (
                    <a href={detail.href}>{detail.text}</a>
                  ) : (
                    <span>{detail.text}</span>
                  )}
                </div>
              ))}
            </article>
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
}